<div style="display:flex; height:100%; width:100%">
  <sat-popover #notifyPopover xAlign="end" yAlign="below" hasBackdrop>
    <div class=" mat-elevation-z4 bg-notifications">
      <cw-ci-notifications #notifications [popover]="notifyPopover"></cw-ci-notifications>
    </div>
  </sat-popover>

  <app-grid-spinner #spinner></app-grid-spinner>

  <div style="width:88px; text-align: center; display: flex; flex-direction: column" class="bg-sidenav">
    <div [satPopoverAnchor]="subNavPopover" style="height: 44px; background-color: #3c9ba0; padding: 5px; box-sizing:border-box; text-align: center; margin-bottom:10px;">
      <img style="height:100%" src="/assets/themes/connectwise-identify/Identify-RGB-Bug-White.svg">
    </div>

    <sat-popover #subNavPopover xAlign="after" yAlign="below" hasBackdrop>
      <div class="bg-sidesubnav" style="height:-webkit-fill-available">
        <mat-nav-list *ngIf="selectedSubMenu == 'INTERNAL'">
          <mat-list-item [routerLink]="['/secured/master/internal/assessments']" [routerLinkActive]="['nav-element-selected']" (click)="subNavPopover.toggle();">
            Assessments
          </mat-list-item>
          <mat-list-item *ngIf="sessionService.hasFeature('ALLOW_SUBACCOUNTS') && sessionService.hasFeature('ANALYTICS_ENABLED')" [routerLink]="['/secured/master/analytics/dashboard']" [routerLinkActive]="['nav-element-selected']" (click)="subNavPopover.toggle();">
            Company Summary
          </mat-list-item>
        </mat-nav-list>
      </div>
    </sat-popover>
      
    <ng-container *ngIf="!sessionService.isAccountType('SYSTEM')">
      <ng-container *ngIf="sessionService.hasFeature('ALLOW_SUBACCOUNTS')">
        <div class="nav-element" [routerLink]="['/secured/master/companies']" [routerLinkActive]="['nav-element-selected']">
          <button mat-icon-button>
            <mat-icon color="primary" svgIcon="cw:companies"></mat-icon>
          </button>
          <span>Companies</span>
        </div>
		
		    <div class="nav-element" (click)="selectedSubMenu='INTERNAL'; subNavPopover.toggle()">							  
          <button mat-icon-button>
            <mat-icon color="primary" svgIcon="cw:companies"></mat-icon>
          </button>
          <span>Internal</span>
        </div>
      </ng-container>

      <ng-container *ngIf="sessionService.hasFeature('ALLOW_CERTIFICATION')">
        <div class="nav-element" [routerLink]="['/secured/master/certification']" [routerLinkActive]="['nav-element-selected']">
          <button mat-icon-button>
            <mat-icon >ballot</mat-icon>
          </button>
          <span>Certifications</span>
        </div>
      </ng-container>

      <ng-container *ngIf="sessionService.hasFeature('ALLOW_SCANNER')">
        <div class="nav-element" [routerLink]="['/secured/master/vulnerabilityScans/scanTargets']" [routerLinkActive]="['nav-element-selected']">
          <button mat-icon-button>
            <mat-icon >policy</mat-icon>
          </button>
          <span>Scans</span>
        </div>
      </ng-container>

      <ng-container *ngIf="!sessionService.hasFeature('ALLOW_SUBACCOUNTS')">
        <div class="nav-element" [routerLink]="['/secured/master/internal/assessments']" [routerLinkActive]="['nav-element-selected']">
          <button mat-icon-button>
            <mat-icon color="primary" svgIcon="cw:companies"></mat-icon>
          </button>
          <span>Assessments</span>
        </div>
      </ng-container>

      <ng-container *ngIf="sessionService.hasFeature('ANALYTICS_ENABLED')">
        <div class="nav-element" [routerLink]="['/secured/master/analytics/industryComparison']" [routerLinkActive]="['nav-element-selected']">
          <button mat-icon-button>
            <mat-icon color="primary" svgIcon="cw:sales"></mat-icon>
          </button>
          <span>Analytics</span>
        </div>
      </ng-container>

      <div class="nav-element" style="margin-top: auto; margin-bottom: 10px;" (click)="onAccountSettingsClicked()">
        <button mat-icon-button>
          <mat-icon svgIcon="cw:application_configuration"></mat-icon>
        </button>
        <span>Settings</span>
      </div>
    </ng-container>

    <ng-container *ngIf="sessionService.isAccountType('SYSTEM')">
      <ng-container *ngIf="sessionService.hasRole(RoleType.ADMIN) || sessionService.hasRole(RoleType.SUPPORT_ADMIN)">
        <div class="nav-element" [routerLink]="['/secured/admin/accounts']" [routerLinkActive]="['nav-element-selected']">
          <button mat-icon-button>
            <mat-icon svgIcon="cw:companies"></mat-icon>
          </button>
          <span>Accounts</span>
        </div>
      </ng-container>

      <ng-container *ngIf="sessionService.hasRole(RoleType.ADMIN) || sessionService.hasRole(RoleType.SUPPORT_ADMIN)">
        <div class="nav-element" [routerLink]="['/secured/admin/users']" [routerLinkActive]="['nav-element-selected']">
          <button mat-icon-button>
            <mat-icon>perm_identity</mat-icon>
          </button>
          <span>Users</span>
        </div>
      </ng-container>

      <ng-container *ngIf="sessionService.hasRole(RoleType.ADMIN) || sessionService.hasRole(RoleType.CERTIFICATION_ADMIN)">
        <div class="nav-element" [routerLink]="['/secured/admin/certification']" [routerLinkActive]="['nav-element-selected']">
          <button mat-icon-button>
            <mat-icon >ballot</mat-icon>
          </button>
          <span>Certifications</span>
        </div>
      </ng-container>
      
      <ng-container *ngIf="sessionService.hasRole(RoleType.ADMIN)">
        <div class="nav-element" [routerLink]="['/secured/admin/assessmentTemplates']" [routerLinkActive]="['nav-element-selected']">
          <button mat-icon-button>
            <mat-icon svgIcon="cw:settings"></mat-icon>
          </button>
          <span>Assessments</span>
        </div>
      </ng-container>

      <ng-container *ngIf="sessionService.hasRole(RoleType.ADMIN)">
        <div class="nav-element" [routerLink]="['/secured/admin/plans']" [routerLinkActive]="['nav-element-selected']">
          <button mat-icon-button>
            <mat-icon svgIcon="cw:settings"></mat-icon>
          </button>
          <span>Plans</span>
        </div>
      </ng-container>

      <ng-container *ngIf="sessionService.hasRole(RoleType.ADMIN)">
        <div class="nav-element" [routerLink]="['/secured/admin/partners']" [routerLinkActive]="['nav-element-selected']">
          <button mat-icon-button>
            <mat-icon svgIcon="cw:settings"></mat-icon>
          </button>
          <span>Partners</span>
        </div>
      </ng-container>

      <ng-container *ngIf="sessionService.hasRole(RoleType.ADMIN)">
        <div class="nav-element" [routerLink]="['/secured/admin/brands']" [routerLinkActive]="['nav-element-selected']">
          <button mat-icon-button>
            <mat-icon svgIcon="cw:settings"></mat-icon>
          </button>
          <span>Report Brands</span>
        </div>
      </ng-container>

      <ng-container *ngIf="sessionService.hasRole(RoleType.ADMIN)">
        <div class="nav-element" [routerLink]="['/secured/admin/notifications']" [routerLinkActive]="['nav-element-selected']">
          <button mat-icon-button>
            <mat-icon svgIcon="cw:application_notification"></mat-icon>
          </button>
          <span>Notifications</span>
        </div>
      </ng-container>

      <ng-container *ngIf="sessionService.hasRole(RoleType.ADMIN)">
        <div class="nav-element" [routerLink]="['/secured/admin/emailTemplates']" [routerLinkActive]="['nav-element-selected']">
          <button mat-icon-button>
            <mat-icon>mail</mat-icon>
          </button>
          <span>Email Templates</span>
        </div>
      </ng-container>

      <ng-container *ngIf="sessionService.hasRole(RoleType.ADMIN)">
        <div class="nav-element" [routerLink]="['/secured/admin/scanConfigurations']" [routerLinkActive]="['nav-element-selected']">
          <button mat-icon-button>
            <mat-icon svgIcon="cw:settings"></mat-icon>
          </button>
          <span>Scan Configurations</span>
        </div>
      </ng-container>
    </ng-container>
  </div>

  <div style="flex: 1 auto" [ngClass]="{'has-message-toolbar':sessionService.isInTrial() || (!sessionService.isAccountType('SYSTEM') && mostRecentSystemAlert()?.isRead == false)}" [ngStyle]="themeManager.getUnderlayStyle(true)">
    <mat-toolbar class="mat-elevation-z2" style="position:relative">
      <!-- <button mat-icon-button matTooltip="Collapse/Expand navigation" matTooltipPosition="right" (click)="snav.toggle()">
        <mat-icon>menu</mat-icon>
      </button> -->
      <span *ngIf="sessionService.getEnvNotification().label" matBadge="?" matBadgeSize="small" matBadgeColor="warn" [matTooltip]="sessionService.getEnvNotification().desc">{{sessionService.getEnvNotification().label}}</span>
      <!-- <a class="logo" [routerLink]="['/secured']" style="position:absolute; top:50%; transform: translateY(-50%); left: 0; right: 0; margin: auto;height: 50px; width: 250px; text-align:center;">
        <img src="{{themeManager.getLayoutLogo()}}" style='max-height: 50px; max-width:250px;'>
      </a> -->
      <div style="margin:0 0 0 auto;">
        <span class="text-warn" style="font-size:0.7em" *ngIf="sessionService.isInTrial()">TRIAL VERSION</span>

        <button matTooltip="Help" matTooltipPosition="left" mat-icon-button [matMenuTriggerFor]="helpMenu">
          <mat-icon>help</mat-icon>
        </button>

        <button *ngIf="!sessionService.isAccountType('SYSTEM')" [satPopoverAnchor]="notifyPopover" matTooltip="Notifications" matTooltipPosition="left" mat-icon-button (click)="notifyPopover.toggle()">
          <mat-icon [matBadgeHidden]="sessionService.countUnreadNotifications() == 0" [matBadge]="sessionService.countUnreadNotifications()" matBadgeColor="warn" matBadgeSize="small" svgIcon="cw:application_notification"></mat-icon>
        </button>
        <button matTooltip="Account Options" matTooltipPosition="left" mat-icon-button [matMenuTriggerFor]="profileMenu">
          <mat-icon>account_circle</mat-icon>
        </button>

        <mat-menu #helpMenu="matMenu" [overlapTrigger]="false">
          <button mat-menu-item color="primary" (click)="openSupport()">
            <mat-icon color="primary">contact_support</mat-icon>
            <span>Contact Us</span>
          </button>  

          <button *ngIf="sessionService.hasFeature('ALLOW_SPLASH_SCREEN')" mat-menu-item color="primary" (click)="onShowSplashScreenClicked()">
            <mat-icon color="primary">whatshot</mat-icon>
            <span>Show Welcome Screen</span>
          </button>
        </mat-menu>

        <mat-menu #profileMenu="matMenu" [overlapTrigger]="false">
          <button mat-menu-item color="primary" (click)="onMyProfileClicked()">
            <mat-icon color="primary">account_circle</mat-icon>
            <span>My Profile</span>
          </button>

          <button *ngIf="sessionService.getApiCredentials().length>1" mat-menu-item [routerLink]="['/secured/accountSelection']" color="primary">
            <mat-icon color="primary">swap_horiz</mat-icon>
            <span>Switch Account</span>
          </button>
          <button mat-menu-item [routerLink]="['/public/logout']" color="primary">
            <mat-icon color="primary">exit_to_app</mat-icon>
            <span>Log Out</span>
          </button>
          <ng-container *ngIf="sessionService.isSystemUser()">
            <mat-divider></mat-divider>
            <button mat-menu-item color="primary" (click)="themeManager.setThemeClass('riskrats-theme')">
              <mat-icon color="primary">palette</mat-icon>
              <span>RiskRATS Theme</span>
            </button>
            <button mat-menu-item color="primary" (click)="themeManager.setThemeClass('sienna-theme')">
              <mat-icon color="primary">palette</mat-icon>
              <span>Sienna Theme</span>
            </button>
            <button mat-menu-item color="primary" (click)="themeManager.setThemeClass('connectwise-theme')">
              <mat-icon color="primary">palette</mat-icon>
              <span>ConnectWise Theme</span>
            </button>
            <button mat-menu-item color="primary" (click)="themeManager.setThemeClass('continuum-theme')">
              <mat-icon color="primary">palette</mat-icon>
              <span>Continuum Theme</span>
            </button>
            <button mat-menu-item color="primary" (click)="themeManager.setThemeClass('alliancebernstein-theme')">
              <mat-icon color="primary">palette</mat-icon>
              <span>Alliance Bernstein Theme</span>
            </button>
            <button mat-menu-item color="primary" (click)="themeManager.setThemeClass('sentrian-theme')">
              <mat-icon color="primary">palette</mat-icon>
              <span>Sentrian Theme</span>
            </button>
            <button mat-menu-item color="primary" (click)="themeManager.setThemeClass('sbam-theme')">
              <mat-icon color="primary">palette</mat-icon>
              <span>SBAM Theme</span>
            </button>
          </ng-container>
        </mat-menu>
      </div>
    </mat-toolbar>
    <mat-toolbar *ngIf="sessionService.isInTrial() && sessionService.getCurrentAccount().parentId == undefined" class="trial-toolbar mat-elevation-z1" style="justify-content:center">
      <span style="font-size: 0.8em;">Trial will expire in {{sessionService.daysLeftInTrial()}} days</span>
      <span style="font-size: 0.5em;padding:0 10px;">|</span>
      <span style="font-size: 0.5em;padding-right: 10px;">You can continue to use ConnectWise Identify after your trial period by purchasing the software.</span>
      <button mat-raised-button class="small text-primary" (click)="buyNow()">Buy Now</button>
    </mat-toolbar>

    <mat-toolbar *ngIf="!sessionService.isInTrial() && !sessionService.isAccountType('SYSTEM') && mostRecentSystemAlert()?.isRead == false" class="system-alert-toolbar selectable mat-elevation-z1" style="justify-content:center" (click)="displaySystemAlert()">
      <mat-icon>info</mat-icon><span style="padding-left:0.4em; font-size: 0.8em;">{{mostRecentSystemAlert().subject}} (click for details)</span>
    </mat-toolbar>
  
    <router-outlet></router-outlet>
  </div>
</div>